<template>
    <div>
        <div class="container mt-2">
            <div class="booking-expand clearfix">
                <div>
                    <div class="row">
                        <div class="col-lg-6 col-xs-12 border-right-responsive">
                            <div class="row mb-3">
                                <div class="col-5 col-lg-6 font-weight-bold">
                                    Mã vé:
                                </div>
                                <div class="col-7 col-lg-6 text-right">
                                    {{getProp(order, 'transaction.id', '')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-5 col-lg-6 font-weight-bold">
                                    Trạng thái thanh toán:
                                </div>
                                <div class="col-7 col-lg-6 text-right">
                                    <p :class="{
                                                'color-danger': status.reject === getProp(order, 'transaction.status'),
                                                'color-success': status.done === getProp(order, 'transaction.status'),
                                                'color-warning': status.processing === getProp(order, 'transaction.status'),
                                                }">
                                        {{getProp(order, 'transaction.status_title', '')}}
                                    </p>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-5 col-lg-6 font-weight-bold">
                                    Tuyến:
                                </div>
                                <div class="col-7 col-lg-6 text-right">
                                    {{getProp(order, 'schedule.voyage.from', '')}} - {{getProp(order, 'schedule.voyage.to', '')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-5 col-lg-6 font-weight-bold">
                                    Thời gian:
                                </div>
                                <div class="col-7 col-lg-6 text-right">
                                    {{format(new Date(getProp(order,
                                    'schedule.start_time', 0)), 'HH:mm')}}
                                    - {{format(new Date(getProp(order,
                                    'schedule.end_time', 0)), 'HH:mm dd/MM/yyyy')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-5 col-lg-6 font-weight-bold">
                                    Khách hàng:
                                </div>
                                <div class="col-7 col-lg-6 text-right">
                                    {{getProp(order, 'customer.name', '')}}
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-12">
                            <div class="row mb-3">
                                <div class="col-lg-6 col-5 font-weight-bold">
                                    Điểm đón:
                                </div>
                                <div class="col-lg-6 col-7 text-right">
                                    {{getProp(order, 'pick_up_locations', []).map(pickup => pickup.address).join(', ')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-6 col-5 font-weight-bold">
                                    Điểm trả:
                                </div>
                                <div class="col-lg-6 col-7 text-right">
                                    {{getProp(order, 'get_off_locations', []).map(getOff => getOff.address).join(', ')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-6 col-5 font-weight-bold">
                                    Số ghế:
                                </div>
                                <div class="col-lg-6 col-7 text-right">
                                    {{getProp(order, 'seats', []).map(seat => getProp(seat, 'p_row', '') + '.' + getProp(seat, 'p_col', '')).join(', ')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-6 col-5 font-weight-bold">
                                    Giá:
                                </div>
                                <div class="col-lg-6 col-7 text-right">
                                    {{getProp(order, 'total_price_pretty', '')}}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-6 col-5 font-weight-bold">
                                    Trạng thái chuyến đi:
                                </div>
                                <div class="col-lg-6 col-7 text-right" :class="{
                                                'color-danger': status.reject === getProp(order, 'status'),
                                                'color-success': status.done === getProp(order, 'status'),
                                                'color-warning': status.processing === getProp(order, 'status'),
                                                }">
                                    {{getProp(order, 'status_title', '')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <button class="btn btn-detail pull-right w100 m-0"
                                    v-if="status.processing === getProp(order, 'status')"
                                    title="Nhấp để hủy vé"
                                    @click.stop="showModalReject">Hủy vé
                            </button>
<!--                            <button class="btn btn-detail pull-right w100 mr-1"-->
<!--                                    v-if="status.processing === getProp(order, 'transaction.status')"-->
<!--                                    title="Nhấp để thanh toán"-->
<!--                                    @click.stop="payment">Thanh toán-->
<!--                            </button>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {RepositoryFactory, MixinHelper} from "../../shared/services";
    import format from "date-fns/format";
    import {HCROUTES} from "../../shared/constants/Constant";

    const repo = RepositoryFactory.get('orders');
    export default {
        name: "OrderDetail",
        mixins: [MixinHelper],
        props: {
            order_id: {
                type: Number,
                required: true
            }
        },
        created() {
            this.singleOrder(this.order_id);
        },
        data() {
            return {
                order: null,
                format,
                status: {
                    processing: 1,
                    done: 2,
                    reject: -1
                },
                showNotify: false,
                resultReject: '',

            }
        },
        methods: {
            singleOrder(order_id) {
                repo.single(order_id)
                    .then(resp => {
                        this.order = this.getProp(resp, 'data.data', null);
                    })
                    .catch(err => {
                    })
            },
            showModalReject() {
                const params = {
                    ...{},
                    content: 'Bạn chắc chắn muốn hủy vé ?',
                    order_id: this.order_id
                };
                this.$modalRejectConfirm.show(params);
            },
            payment() {
                this.$router.push({name: HCROUTES.payment, query: {order_id: this.order_id}})
            }
        }
    }
</script>

<style scoped>
    .booking-expand {
        background: #f0f0f0;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 2px;
        padding-right: 2px;
        position: relative;
        border-radius: 5px;
    }
    .border-right-responsive {
        border-right: 1px solid #dcdcdc;
    }

    @media (max-width: 991px) {
        .border-right-responsive {
            border-right: 0;
        }
    }
</style>
